<app-widget-option [categories]="['INDICATORS']" [label]="'REMOVE'">
  <div app-widget-option-content>
   <button mdbBtn (click)="onRemove()" type="button" color="light" size="sm" class="px-2 z-depth-0 m-0" mdbWavesEffect>
      <i class="fas fa-trash fa-fw text-warning"></i>
    </button>
  </div>
</app-widget-option>